import Request, { SimpleResponse } from './Request';
import { IProfile } from './Profile';
import { IGroup } from './Group';

export interface IUser {
    active: boolean;
    email: string;
    group: IGroup;
    id: number;
    ip: string;
    name: string;
    picture: string;
    password: string;
    profile: IProfile;
    bearer: string;
    basicLayout: boolean;
}

export interface IUserMessage {
    id: number;
    name: string;
    code: string;
    year: number;
    month: number;
    message: string;
}

class User {
    static GetAll = (): IUser[] => { return Request.DoGet('user/all') as unknown as IUser[]; };
    static Get = (id: Number): IUser => { return Request.DoGet('user/' + id) as unknown as IUser; };
    static UpdateInfo = (id: Number, data: any): SimpleResponse => { return Request.DoPut('user/info/' + id, data, 'multipart/form-data') as unknown as SimpleResponse; };
    static GetInfo = async (): Promise<IUser> => {
        const response = await Request.DoGet('user/info') as any;
        return response?.user ?? response;
    };
    static Update = (id: Number, data: IUser): SimpleResponse => { return Request.DoPut('user/' + id, data) as unknown as SimpleResponse; };
    static Create = (data: IUser): SimpleResponse => { return Request.DoPost('user', data) as unknown as SimpleResponse; };
    static Delete = (id: Number): SimpleResponse => { return Request.DoDelete('user/' + id) as unknown as SimpleResponse; };
    static Messages = (): IUserMessage[] => { return Request.DoGet('user/messages') as unknown as IUserMessage[]; };

}

export default User;
